import { render, staticRenderFns } from "./comparative-search-card.vue?vue&type=template&id=55f7d344&"
import script from "./comparative-search-card.ts?vue&type=script&lang=ts&"
export * from "./comparative-search-card.ts?vue&type=script&lang=ts&"
import style0 from "./comparative-search-card.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports